import { render, staticRenderFns } from "./TeacherShortLayout.vue?vue&type=template&id=d80e171a&scoped=true"
import script from "./TeacherShortLayout.vue?vue&type=script&lang=js"
export * from "./TeacherShortLayout.vue?vue&type=script&lang=js"
import style0 from "./TeacherShortLayout.vue?vue&type=style&index=0&id=d80e171a&prod&scoped=true&lang=scss"
import style1 from "./TeacherShortLayout.vue?vue&type=style&index=1&id=d80e171a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d80e171a",
  null
  
)

export default component.exports